import { IRapport } from '../../_Common/Const/Delsystem';
import Forsamlingsstatistik from './Forsamlingsstatistik/Forsamlingsstatistik';

const BORapporter: { [rapportID: string]: IRapport } = {
  BOForsamlingsstatistik: {
    component: Forsamlingsstatistik,
  },
};

export default BORapporter;
